/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Request = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SuperagentResponse = require('./SuperagentResponse');

var _LambdaResponse = require('./LambdaResponse');

var _Response = require('./Response');

var _Exception = require('../Exception/Exception');

var _Action = require('./Action');

var _RetryManager = require('./RetryManager');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

var _MissingCacheImplementationException = require('./Exception/MissingCacheImplementationException');

var _CachedRequestException = require('./Exception/CachedRequestException');

var _aws = require('aws4');

var _aws2 = _interopRequireDefault(_aws);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _MissingSecurityServiceException = require('./Exception/MissingSecurityServiceException');

var _AsyncCallNotAvailableException = require('./Exception/AsyncCallNotAvailableException');

var _LambdaParamsCompatibilityException = require('./Exception/LambdaParamsCompatibilityException');

var _LoadCredentialsException = require('./Exception/LoadCredentialsException');

var _SourceNotAvailableException = require('./Exception/SourceNotAvailableException');

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

var _util = require('util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Action request instance
 */
let Request = function () {
  /**
   * @param {Action} action
   * @param {Object} payload
   * @param {String} method
   */
  function Request(action, payload, method) {
    _classCallCheck(this, Request);

    this._action = action;
    this._payload = payload;
    this._method = method;
    this._lambda = new _awsSdk2.default.Lambda();

    this._cacheImpl = null;
    this._cacheTtl = Request.TTL_FOREVER;
    this._cached = false;
    this._publicCached = false;

    this._async = false;
    this._xhrAsync = true; // it's passed to httpOptions.xhrAsync option of AWS Service
    this._native = false;

    this._validationSchemaName = null;

    this._customId = null;
    this._returnLogs = false;

    this._withUserCredentials = true;
    this._authScope = this._buildAuthScope();

    this._apiKey = null;

    this._baseUrl = null;

    this._retryManager = new _RetryManager.RetryManager(['internal-error']);
  }

  /**
   * @param {String} url
   * @returns {LocalRequest}
   */


  _createClass(Request, [{
    key: 'baseUrl',
    value: function baseUrl(url) {
      this._baseUrl = url;

      return this;
    }

    /**
     * @returns {String|null}
     */

  }, {
    key: 'skipLoadingCredentials',


    /**
     * @returns {Request}
     */
    value: function skipLoadingCredentials() {
      this._withUserCredentials = false;

      return this;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'skipPreValidation',


    /**
     * @returns {Request}
     */
    value: function skipPreValidation() {
      this._validationSchemaName = null;

      return this;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'invokeAsync',


    /**
     * @returns {Request}
     */
    value: function invokeAsync() {
      if (!this.isLambda) {
        throw new _AsyncCallNotAvailableException.AsyncCallNotAvailableException(this._action.type);
      }

      if (this._returnLogs) {
        throw new _LambdaParamsCompatibilityException.LambdaParamsCompatibilityException({
          InvocationType: 'Event',
          LogType: 'Tail'
        });
      }

      this._native = true;
      this._async = true;

      return this;
    }

    /**
     * @param {Boolean} flag
     *
     * @returns {Request}
     */

  }, {
    key: 'httpXhrAsync',
    value: function httpXhrAsync(flag) {
      if (!this.isLambda) {
        throw new _Exception.Exception('XHR sync requests are supported only for calls to lambda functions.', 400);
      }

      this._xhrAsync = !!flag;

      return this;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'useDirectCall',


    /**
     * @param {Boolean} returnLogs
     * @returns {Request}
     */
    value: function useDirectCall() {
      let returnLogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this._async && returnLogs) {
        throw new _LambdaParamsCompatibilityException.LambdaParamsCompatibilityException({
          InvocationType: 'Event',
          LogType: 'Tail'
        });
      }

      this._native = true;
      this._returnLogs = returnLogs;

      return this;
    }

    /**
     * @returns {Request}
     */

  }, {
    key: 'usePublicCache',
    value: function usePublicCache() {
      this._publicCached = true;
      return this;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'enableCache',


    /**
     * @returns {Request}
     */
    value: function enableCache() {
      this._cached = true;
      return this;
    }

    /**
     * @returns {Request}
     */

  }, {
    key: 'disableCache',
    value: function disableCache() {
      this._cached = false;
      return this;
    }

    /**
     * @param {Number} ttl
     * @returns {Request}
     */

  }, {
    key: 'cache',
    value: function cache() {
      let ttl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Request.TTL_FOREVER;

      if (!this._cacheImpl) {
        throw new _MissingCacheImplementationException.MissingCacheImplementationException();
      }

      this._cacheTtl = ttl;
      this.enableCache();

      return this;
    }

    /**
     * @param {Number} count
     * @returns {Request}
     */

  }, {
    key: 'retry',
    value: function retry(count) {
      this._retryManager.count = count;
      return this;
    }

    /**
     * @param {Function|String} strategy
     * @param {Object[]} args 
     * @returns {Request}
     */

  }, {
    key: 'addRetryStrategy',
    value: function addRetryStrategy(strategy) {
      var _retryManager;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_retryManager = this._retryManager).addStrategy.apply(_retryManager, [strategy].concat(args));
      return this;
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'authScope',


    /**
     * @param {String|null} authScope
     * @returns {Request}
     */
    value: function authScope(_authScope) {
      this._authScope = _authScope;

      return this;
    }

    /**
     * @param {String} key
     * @returns {Request}
     */

  }, {
    key: 'apiKey',
    value: function apiKey(key) {
      this._apiKey = key;

      return this;
    }

    /**
     * @returns {String}
     * @private
     */

  }, {
    key: '_buildCacheKey',
    value: function _buildCacheKey() {
      let payload = Request._md5(JSON.stringify(this.payload));
      let endpoint = this.native ? this._action.source.original : this._action.source.api;

      return `${this._method}:${this._action.type}:${endpoint}#${payload}`;
    }

    /**
     * @param {String} str
     * @returns {String}
     */

  }, {
    key: '_rebuildResponse',


    /**
     * @param {String|Object} rawData
     * @returns {Response}
     * @private
     */
    value: function _rebuildResponse(rawData) {
      let response = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

      if (!response) {
        throw new _CachedRequestException.CachedRequestException(`Unable to unpack cached JSON object from ${rawData}`);
      }

      if (response._class) {
        let ResponseImpl = Request._chooseResponseImpl(response._class);

        if (!ResponseImpl) {
          throw new _Exception.Exception(`Unknown Response implementation ${response._class}`);
        }

        return new ResponseImpl(this, response.data, response.error);
      }

      return new _SuperagentResponse.SuperagentResponse(this, response, null);
    }

    /**
     * @param {String} className
     * @returns {*}
     * @private
     */

  }, {
    key: 'invalidateCache',


    /**
     *
     * @param {Function} callback
     * @returns {Request}
     */
    value: function invalidateCache() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      if (!this.isCached) {
        callback(true);

        return this;
      }

      let cache = this._cacheImpl;
      let cacheKey = this._buildCacheKey();

      cache.has(cacheKey, (error, result) => {
        if (error) {
          throw new _CachedRequestException.CachedRequestException(error);
        }

        if (result) {
          cache.invalidate(cacheKey, 0, (error, result) => {
            if (error) {
              throw new _CachedRequestException.CachedRequestException(error);
            }

            callback(result);
          });

          return;
        }

        callback(true);
      });

      return this;
    }

    /**
     * @param {Function} callback
     * @returns {Request}
     */

  }, {
    key: 'send',
    value: function send() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      let cache = this.cacheImpl;
      let cacheKey = this._buildCacheKey();

      if (!this.isCached || this._async || this.cacheTtl === Request.TTL_INVALIDATE) {
        return this._send(callback);
      }

      this._loadResponseFromCache(cache, cacheKey, (error, response) => {
        if (!error) {
          callback(response);
          return;
        }

        if (this.isPublicCached) {
          let publicCache = cache.shared;
          let publicCacheKey = publicCache.buildKeyFromRequest(this);

          this._loadResponseFromCache(publicCache, publicCacheKey, (error, response) => {
            if (!error) {
              callback(response);
              return;
            }

            this._send(callback);
          });
        } else {
          this._send(callback);
        }
      });

      return this;
    }

    /**
     * @param {Function} callback
     * @returns {Request}
     */

  }, {
    key: '_send',
    value: function _send() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      let logService = this.action.resource.log;
      let requestEvent = {
        service: 'deep-resource',
        resourceType: 'Browser',
        resourceId: this.native ? this.action.source.original : this.action.source.api,
        eventName: this.method,
        eventId: this.customId,
        requestId: this.customId,
        time: Date.now()
      };

      let decoratedCallback = response => {
        if (this._retryManager.isRetryable(response)) {
          return this._send(callback);
        }

        if (this.method.toUpperCase() === 'GET') {
          this._saveResponseToCache(response);
        }

        requestEvent.requestId = requestEvent.mainRequestId = response.requestId;

        let responseEvent = _util2.default._extend({}, requestEvent);
        responseEvent.payload = response;
        responseEvent.time = Date.now();

        logService.rumLog(requestEvent);
        logService.rumLog(responseEvent);

        callback(response);
      };

      if (this.validationSchemaName) {
        let result = this._validate();

        if (result.error) {
          return decoratedCallback(this._createValidationErrorResponse(result.error));
        }
      }

      this._fillPayloadWithSystemData();

      if (!this._native) {
        return this._sendThroughApi(decoratedCallback);
      }

      switch (this._action.type) {
        case _Action.Action.LAMBDA:
          if (!this._action.isOriginalSourceInvokable) {
            throw new _SourceNotAvailableException.SourceNotAvailableException(_Action.Action.LAMBDA, this._action);
          }

          this._sendLambda(decoratedCallback);
          break;
        case _Action.Action.EXTERNAL:
          if (!this._action.isApiSourceInvokable) {
            throw new _SourceNotAvailableException.SourceNotAvailableException(_Action.Action.EXTERNAL, this._action);
          }

          this._sendExternal(decoratedCallback);
          break;
        default:
          throw new _Exception.Exception(`Request of type ${this._action.type} is not implemented`);
      }

      return this;
    }

    /**
     * @returns {Request}
     * @private
     */

  }, {
    key: '_fillPayloadWithSystemData',
    value: function _fillPayloadWithSystemData() {
      let resource = this.action.resource;

      if (!resource.isBackend || !resource.log.isRumEnabled()) {
        return this;
      }

      let runtimeContext = resource.contextProvider.context;

      this._payload.lambdaDepthLevel = (runtimeContext.getDeepFrameworkOption('lambdaDepthLevel') || 0) + 1;
      this._payload.mainRequestId = runtimeContext.getDeepFrameworkOption('mainRequestId') || runtimeContext.awsRequestId;

      return this;
    }

    /**
     * @param {Object} response
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_saveResponseToCache',
    value: function _saveResponseToCache(response) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      if (!this.isCached || this.async || this.cacheTtl === Request.TTL_INVALIDATE || response.isError) {
        callback(null, response);
        return;
      }

      let cacheKey = this._buildCacheKey();
      let logService = this.action.resource.log;

      let event = {
        service: 'deep-cache',
        resourceType: this.cacheImpl.type(),
        resourceId: cacheKey,
        eventName: 'set',
        requestId: response.requestId
      };

      logService.rumLog(event);

      this.cacheImpl.set(cacheKey, Request._stringifyResponse(response), this.cacheTtl, (error, result) => {
        event = _util2.default._extend({}, event);
        event.payload = { error: error, result: result };
        logService.rumLog(event);

        if (!error && !result) {
          error = `Unable to persist request cache under key ${cacheKey}.`;
        }

        if (error) {
          error = new _CachedRequestException.CachedRequestException(error);
        }

        callback(error, result);

        return;
      });
    }

    /**
     * @param {Object} driver
     * @param {String|Key} key
     * @param {Function} callback
     */

  }, {
    key: '_loadResponseFromCache',
    value: function _loadResponseFromCache(driver, key, callback) {
      driver.has(key, (err, has) => {
        if (err) {
          callback(new _CachedRequestException.CachedRequestException(`Error to check if has in cache key ${key}`));
          return;
        }

        if (has) {
          let logService = this.action.resource.log;

          let event = {
            service: 'deep-cache',
            resourceType: driver.type(),
            resourceId: key,
            eventName: 'get',
            requestId: this.customId
          };

          logService.rumLog(event);

          driver.get(key, (err, data) => {
            event = _util2.default._extend({}, event);
            event.payload = { err: err, data: data };

            logService.rumLog(event);

            if (err) {
              callback(err, null);

              return;
            }

            callback(null, this._rebuildResponse(data));
          });

          return;
        }

        callback(new _CachedRequestException.CachedRequestException(`Missing key ${key}`), null);
      });
    }

    /**
     * @returns {Object}
     * @private
     */

  }, {
    key: '_validate',
    value: function _validate() {
      if (!this.validationSchemaName) {
        throw new _Exception.Exception('Error on validating request. Validation schema is not defined.');
      }

      return this.action.resource.validation.validate(this.validationSchemaName, this.payload, true);
    }

    /**
     * @param {Error} validationError
     *
     * @returns {LambdaResponse}
     * @private
     */

  }, {
    key: '_createValidationErrorResponse',
    value: function _createValidationErrorResponse(validationError) {
      return new _LambdaResponse.LambdaResponse(this, {
        errorMessage: JSON.stringify({
          errorType: validationError.name,
          errorMessage: validationError.annotate(),
          errorStack: validationError.stack || new Error(validationError.message).stack,
          validationErrors: validationError.details
        })
      }, null);
    }

    /**
     * @param {Function} callback
     * @returns {Request}
     * @private
     */

  }, {
    key: '_sendThroughApi',
    value: function _sendThroughApi() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      let endpoint = this.action.source.api;
      let headers = {};

      let sendRequestFunc = request => {
        request.end((error, response) => {
          callback(new _SuperagentResponse.SuperagentResponse(this, response, error));
        });
      };

      // make sure apiKey is set for endpoints that requires it
      if (this.action.apiKeyRequired) {
        if (!this._apiKey) {
          callback(new _SuperagentResponse.SuperagentResponse(this, null, new Error('Missing required api key parameter.')));

          return this;
        }

        headers = { 'x-api-key': this._apiKey };
      }

      if (this.action.apiAuthType === _Action.Action.API_AWS_IAM_AUTH) {
        this._createAws4SignedRequest(endpoint, this.method, this.payload, headers, (error, signedRequest) => {
          if (error) {
            callback(new _SuperagentResponse.SuperagentResponse(this, null, error));
            return this;
          }

          sendRequestFunc(signedRequest);
        });
      } else {
        sendRequestFunc(this._createBasicHttpRequest(endpoint, this.method, this.payload, headers));
      }

      return this;
    }

    /**
     * @param {Function} callback
     * @returns {Request}
     * @private
     */

  }, {
    key: '_sendLambda',
    value: function _sendLambda() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};


      // @todo: set retries in a smarter way...
      _awsSdk2.default.config.maxRetries = 3;

      let options = {
        region: this._action.region,
        httpOptions: {
          xhrAsync: this.xhrAsync
        }
      };

      let invocationParameters = {
        FunctionName: this._action.source.original,
        Payload: JSON.stringify(this.payload),
        InvocationType: this._async ? 'Event' : 'RequestResponse',
        LogType: this._returnLogs ? 'Tail' : 'None'
      };

      if (!this.withUserCredentials) {
        this._invokeLambda(invocationParameters, callback);
      } else {
        this._loadSecurityCredentials((error, credentials) => {

          // use cognito identity credentials if present
          // if not, fallback to lambda execution role permissions
          if (!error && credentials) {
            options.credentials = credentials;
          }

          this._lambda = new _awsSdk2.default.Lambda(options);

          this._invokeLambda(invocationParameters, callback);
        });
      }

      return this;
    }

    /**
     * @param {Object} invocationParameters
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_invokeLambda',
    value: function _invokeLambda(invocationParameters, callback) {
      let _this = this;

      // @note - don't replace this callback function with an arrow one
      // (we need injected context to access AWS.Response)
      this._lambda.invoke(invocationParameters, function (error, data) {
        let lambdaResponse = new _LambdaResponse.LambdaResponse(_this, data, error);
        lambdaResponse.originalResponse = this; // this is an instance of AWS.Response

        callback(lambdaResponse);
      });
    }

    /**
     * @param {String} url
     * @param {String} method
     * @param {*} payload
     * @param {*} headers
     * @returns {*}
     * @private
     */

  }, {
    key: '_createBasicHttpRequest',
    value: function _createBasicHttpRequest(url) {
      let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.method;
      let payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.payload;
      let headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      let request = _superagent2.default[Request._httpRealMethod(method)](url, payload);

      for (let headerName in headers) {
        if (!headers.hasOwnProperty(headerName)) {
          continue;
        }

        request.set(headerName, headers[headerName]);
      }

      return request;
    }

    /**
     * @param {Function} callback
     * @returns {Request}
     * @private
     */

  }, {
    key: '_sendExternal',
    value: function _sendExternal() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      this._createBasicHttpRequest(this._action.source.original).send().end((error, response) => {
        callback(new _SuperagentResponse.SuperagentResponse(this, response, error));
      });

      return this;
    }

    /**
     * @param {String} url
     * @param {String} httpMethod
     * @param {Object} payload
     * @param {Object} headers
     * @param {Function} callback
     * @private
     */

  }, {
    key: '_createAws4SignedRequest',
    value: function _createAws4SignedRequest(url, httpMethod, payload, headers, callback) {
      let parsedUrl = (0, _urlParse2.default)(url, _qs2.default);
      let apiHost = parsedUrl.hostname;
      let apiPath = parsedUrl.pathname ? parsedUrl.pathname : '/';

      headers = _util2.default._extend(headers, {
        'Content-Type': 'application/json; charset=UTF-8'
      });

      let opsToSign = {
        service: _deepCore2.default.AWS.Service.API_GATEWAY_EXECUTE,
        region: this.getEndpointHostRegion(apiHost),
        host: apiHost,
        method: httpMethod,
        path: apiPath,
        headers: _util2.default._extend({}, headers) // clone headers object not to be changed by aws4.sign method
      };

      httpMethod = httpMethod.toLowerCase();

      switch (httpMethod) {
        case 'get':
        case 'delete':
          if (parsedUrl.query || payload) {
            //assure parsedUrl.query is a valid object
            if (parsedUrl.query === null || typeof parsedUrl.query !== 'object') {
              parsedUrl.query = {};
            }

            let mergedPayload = _util2.default._extend(parsedUrl.query, payload);

            if (this.action.apiCacheEnabled) {
              mergedPayload[_Action.Action.DEEP_CACHE_QS_PARAM] = Request._md5(_qs2.default.stringify(mergedPayload));
            }

            opsToSign.path += `?${_qs2.default.stringify(mergedPayload)}`;

            // pass payload as query string
            parsedUrl.set('query', mergedPayload, _qs2.default.parse);
            url = parsedUrl.toString(_qs2.default.stringify);
            payload = null; // reset it coz superagent overrides url query string
          }
          break;
        case 'post':
        case 'put':
        case 'patch':
          payload = JSON.stringify(payload);
          opsToSign.body = payload;
          break;
      }

      this._loadSecurityCredentials((error, credentials) => {
        if (error) {
          callback(error);
          return;
        }

        let signature = _aws2.default.sign(opsToSign, credentials);
        let request = this._createBasicHttpRequest(url, httpMethod, payload, headers);

        // Adding aws4 required headers
        ['X-Amz-Date', 'X-Amz-Security-Token', 'Authorization'].forEach(header => {
          request.set(header, signature.headers[header]);
        });

        if (this.action.resource.isBackend && signature.headers.hasOwnProperty('Content-Length')) {
          request.set('Content-Length', signature.headers['Content-Length']);
        }

        callback(null, request);
      });
    }

    /**
     * @param {String} httpMethod
     * @returns {String}
     * @private
     */

  }, {
    key: '_loadSecurityCredentials',


    /**
     * @param {Function} callback
     * @returns {Request}
     * @private
     */
    value: function _loadSecurityCredentials(callback) {
      let securityService = this._action.resource.security;

      if (!securityService) {
        callback(new _MissingSecurityServiceException.MissingSecurityServiceException(), null);
        return this;
      }

      let loadCredentialsFunc = securityToken => {
        securityToken.loadCredentials((error, credentials) => {
          if (error) {
            callback(new _LoadCredentialsException.LoadCredentialsException(error), null);
            return;
          }

          callback(null, credentials);
        }, this._authScope);
      };

      if (securityService.token) {
        loadCredentialsFunc(securityService.token);
      } else {
        loadCredentialsFunc(securityService.anonymousLogin(() => {}));
      }

      return this;
    }

    /**
     * @param {String} endpointHost
     * @returns {String}
     */

  }, {
    key: 'getEndpointHostRegion',
    value: function getEndpointHostRegion(endpointHost) {
      let regionParts = endpointHost.match(/\.([^\.]+)\.amazonaws\.com$/i);

      // @todo - expose API region into config provision section
      return regionParts ? regionParts[1] : this._action.region; // use action region as fallback
    }

    /**
     * @return {String}
     */

  }, {
    key: '_buildAuthScope',
    value: function _buildAuthScope() {
      let action = this._action;
      let resource = action.resource;
      let microservice = resource.microservice;

      return `${microservice.identifier}:${resource.name}:${action.name}`;
    }

    /**
     * @returns {Action}
     */

  }, {
    key: 'baseUrl',
    get: function get() {
      if (!this._baseUrl) {
        this._baseUrl = this._action.baseUrl;
      }

      return this._baseUrl;
    }
  }, {
    key: 'withUserCredentials',
    get: function get() {
      if (this.action.scope === 'private') {
        this._withUserCredentials = false;
      }

      return this._withUserCredentials;
    }
  }, {
    key: 'validationSchemaName',
    get: function get() {
      return this._validationSchemaName;
    }

    /**
     * @param {String} validationSchemaName
     */
    ,
    set: function set(validationSchemaName) {
      this._validationSchemaName = validationSchemaName;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'async',
    get: function get() {
      return this._async;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'xhrAsync',
    get: function get() {
      return this._xhrAsync;
    }

    /**
     * @returns {Boolean}
     *
     * @todo: remove this?
     */

  }, {
    key: 'isLambda',
    get: function get() {
      return this._action.type === _Action.Action.LAMBDA;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'customId',
    get: function get() {
      if (!this._customId) {
        this._customId = Request._md5(this._buildCacheKey() + new Date().getTime());
      }

      return this._customId;
    }
  }, {
    key: 'native',
    get: function get() {
      return this._native;
    }
  }, {
    key: 'isCached',
    get: function get() {
      return this._cacheImpl && this._cached;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'isPublicCached',
    get: function get() {
      return this._publicCached && this._cacheImpl && this._cacheImpl.shared;
    }
  }, {
    key: 'cacheTtl',
    get: function get() {
      return this._cacheTtl;
    }

    /**
     * @param {Number} ttl
     */
    ,
    set: function set(ttl) {
      this._cacheTtl = ttl;
    }

    /**
     * @returns {Cache}
     */

  }, {
    key: 'cacheImpl',
    get: function get() {
      return this._cacheImpl;
    }

    /**
     * @param {Cache} cache
     */
    ,
    set: function set(cache) {
      this._cacheImpl = cache;

      // @todo: do we really have to force it?
      this.cache(Request.TTL_DEFAULT);
    }
  }, {
    key: 'action',
    get: function get() {
      return this._action;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'payload',
    get: function get() {
      return this._payload;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'method',
    get: function get() {
      return this._method;
    }

    /**
     * @returns {Number}
     * @constructor
     */

  }], [{
    key: '_md5',
    value: function _md5(str) {
      var md5sum = _crypto2.default.createHash('md5');

      md5sum.update(str);

      return md5sum.digest('hex');
    }

    /**
     * @param {Response} response
     * @returns {String}
     * @private
     */

  }, {
    key: '_stringifyResponse',
    value: function _stringifyResponse(response) {
      let objToStr = {
        _class: response.constructor.name,
        data: response.rawData,
        error: response.rawError,
        headers: response.headers
      };

      if (response.constructor.name === _SuperagentResponse.SuperagentResponse.name) {
        objToStr.data = {
          body: response.rawData.body,
          status: response.rawData.status,
          headers: response.rawData.headers
        };
      }

      return JSON.stringify(objToStr);
    }
  }, {
    key: '_chooseResponseImpl',
    value: function _chooseResponseImpl(className) {
      let implMap = {};

      implMap[_Response.Response.name] = _Response.Response;
      implMap[_LambdaResponse.LambdaResponse.name] = _LambdaResponse.LambdaResponse;
      implMap[_SuperagentResponse.SuperagentResponse.name] = _SuperagentResponse.SuperagentResponse;

      return implMap[className];
    }
  }, {
    key: '_httpRealMethod',
    value: function _httpRealMethod(httpMethod) {
      let method = httpMethod.toLowerCase();

      // @see https://visionmedia.github.io/superagent/
      if (method === 'delete') {
        method = 'del';
      }

      return method;
    }
  }, {
    key: 'TTL_DEFAULT',
    get: function get() {
      return 10;
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'TTL_INVALIDATE',
    get: function get() {
      return -1;
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'TTL_FOREVER',
    get: function get() {
      return 0;
    }
  }]);

  return Request;
}();

exports.Request = Request;


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Request.js
// module id = 175
// module chunks = 0